"use client"
import WorkOrderDeleteDialog from "./work-order-delete-dialog"

interface WorkOrderDeleteDialogWrapperProps {
    workOrderId: number
    orderNumber?: string | null
}

function WorkOrderDeleteDialogWrapper({
    workOrderId,
    orderNumber,
}: WorkOrderDeleteDialogWrapperProps) {
    return (
        <>
            <WorkOrderDeleteDialog
                workOrderId={workOrderId}
                orderNumber={orderNumber}
            />
        </>
    )
}

export default WorkOrderDeleteDialogWrapper
